import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';
import GoogleSignInButton from '../components/Auth/GoogleSignInButton';
import GoogleOneTap from '../components/Auth/GoogleOneTap';
import AuthShell, { inputClass, labelClass, buttonClass, Notice, Divider } from '../components/Auth/AuthShell';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await login(email, password);
      if (!result.success) {
        setError(result.error || 'Login failed');
      }
    } catch (err) {
      setError('An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle={<>New to AirBrief? <Link to="/register" className="font-medium text-primary-300 hover:text-primary-200">Create an account</Link></>}
    >
      <GoogleOneTap />
      <GoogleSignInButton variant="light" text="Continue with Google" className="w-full !rounded-lg !py-3" disabled={loading} />

      <Divider>or sign in with email</Divider>

      <form className="space-y-5" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email" className={labelClass}>Email</label>
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputClass}
            placeholder="you@example.com"
          />
        </div>

        <div>
          <div className="flex items-center justify-between">
            <label htmlFor="password" className={labelClass}>Password</label>
            <Link to="/forgot-password" className="mb-1.5 text-sm font-medium text-primary-300 hover:text-primary-200">
              Forgot password?
            </Link>
          </div>
          <div className="relative">
            <input
              id="password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`${inputClass} pr-11`}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-white"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? <EyeSlashIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
            </button>
          </div>
        </div>

        {error && <Notice>{error}</Notice>}

        <button type="submit" disabled={loading} className={buttonClass}>
          {loading ? <span className="h-4 w-4 animate-spin rounded-full border-b-2 border-white" /> : 'Sign in'}
        </button>
      </form>
    </AuthShell>
  );
};

export default Login;
